import localec5b99526 from '../../language/en-GB.json'
import locale4e449542 from '../../language/de-DE.json'
import locale35af4c7f from '../../language/es-ES.json'
import locale6e349d82 from '../../language/fr-FR.json'
import locale7067459f from '../../language/it-IT.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en-GB","dateTimeFormats":{"en-GB":{"short":{"day":"numeric","month":"short","weekday":"short"},"dateWithYear":{"day":"numeric","month":"short","year":"numeric","timeZone":"Europe/London"},"dateWithYearAndTimeInUTC":{"day":"numeric","month":"short","year":"numeric","hour":"numeric","minute":"numeric","hour12":true,"timeZone":"UTC"},"dateWithYearAndWeekday":{"weekday":"short","day":"numeric","month":"short","year":"numeric"},"hours":{"hour":"numeric","hour12":true,"timeZone":"Europe/London"},"hoursWithMinutes":{"hour":"numeric","minute":"numeric","hour12":true,"timeZone":"Europe/London"}},"de-DE":{"short":{"day":"numeric","month":"short","weekday":"short"},"dateWithYear":{"day":"numeric","month":"short","year":"numeric","timeZone":"Europe/Berlin"},"dateWithYearAndTimeInUTC":{"day":"numeric","month":"short","year":"numeric","hour":"numeric","minute":"numeric","hour12":false,"timeZone":"UTC"},"dateWithYearAndWeekday":{"weekday":"short","day":"numeric","month":"short","year":"numeric"},"hours":{"hour":"numeric","hour12":false,"timeZone":"Europe/Berlin"},"hoursWithMinutes":{"hour":"numeric","minute":"numeric","hour12":false,"timeZone":"Europe/Berlin"}},"es-ES":{"short":{"day":"numeric","month":"short","weekday":"short"},"dateWithYear":{"day":"numeric","month":"short","year":"numeric","timeZone":"Europe/Berlin"},"dateWithYearAndTimeInUTC":{"day":"numeric","month":"short","year":"numeric","hour":"numeric","minute":"numeric","hour12":false,"timeZone":"UTC"},"dateWithYearAndWeekday":{"weekday":"short","day":"numeric","month":"short","year":"numeric"},"hours":{"hour":"numeric","hour12":false,"timeZone":"Europe/Madrid"},"hoursWithMinutes":{"hour":"numeric","minute":"numeric","hour12":false,"timeZone":"Europe/Madrid"}},"fr-FR":{"short":{"day":"numeric","month":"short","weekday":"short"},"dateWithYear":{"day":"numeric","month":"short","year":"numeric","timeZone":"Europe/Berlin"},"dateWithYearAndTimeInUTC":{"day":"numeric","month":"short","year":"numeric","hour":"numeric","minute":"numeric","hour12":false,"timeZone":"UTC"},"dateWithYearAndWeekday":{"weekday":"short","day":"numeric","month":"short","year":"numeric"},"hours":{"hour":"numeric","hour12":false,"timeZone":"Europe/Paris"},"hoursWithMinutes":{"hour":"numeric","minute":"numeric","hour12":false,"timeZone":"Europe/Paris"}},"it-IT":{"short":{"day":"numeric","month":"short","weekday":"short"},"dateWithYear":{"day":"numeric","month":"short","year":"numeric","timeZone":"Europe/Berlin"},"dateWithYearAndTimeInUTC":{"day":"numeric","month":"short","year":"numeric","hour":"numeric","minute":"numeric","hour12":false,"timeZone":"UTC"},"dateWithYearAndWeekday":{"weekday":"short","day":"numeric","month":"short","year":"numeric"},"hours":{"hour":"numeric","hour12":false,"timeZone":"Europe/Rome"},"hoursWithMinutes":{"hour":"numeric","minute":"numeric","hour12":false,"timeZone":"Europe/Rome"}}},"numberFormats":{"en-GB":{"currency":{"style":"currency","currency":"GBP"}},"de-DE":{"currency":{"style":"currency","currency":"EUR"}},"es-ES":{"currency":{"style":"currency","currency":"EUR"}},"fr-FR":{"currency":{"style":"currency","currency":"EUR"}},"it-IT":{"currency":{"style":"currency","currency":"EUR"}}}},
  vueI18nLoader: false,
  locales: [{"code":"en-GB","country":"UK","iso":"en","domain":"www.lenstore.co.uk","api":"https://api.lenstore.co.uk","gtmContainerId":"GTM-PRPG3NS","cookieProId":"d5e286e2-7ed4-4826-99a3-691e6712cb1f","cookieProLegacyDomain":".www.lenstore.co.uk","file":"en-GB.json","currencyCode":"GBP","opticianBrandLogo":{"fileName":"vision-express","type":"png"}},{"code":"de-DE","country":"DE","iso":"de","domain":"www.lenstore.de","api":"https://api.lenstore.de","gtmContainerId":"GTM-PCSWQNN","cookieProId":"150bfe9b-de1c-458b-8e09-999cd4bcb0b2","cookieProLegacyDomain":".www.lenstore.de","file":"de-DE.json","currencyCode":"EUR","opticianBrandLogo":{"fileName":"apollo","type":"svg"}},{"code":"es-ES","country":"ES","iso":"es","domain":"www.lenstore.es","api":"https://api.lenstore.es","gtmContainerId":"GTM-K4P2MVD","cookieProId":"7d27f974-adf3-46cb-afd5-bce275e173c7","cookieProLegacyDomain":".lenstore.es","file":"es-ES.json","currencyCode":"EUR","opticianBrandLogo":{"fileName":"masvision","type":"svg"}},{"code":"fr-FR","country":"FR","iso":"fr","domain":"www.lenstore.fr","api":"https://api.lenstore.fr","gtmContainerId":"GTM-NKGFRFG","cookieProId":"d941b357-8916-4bc4-b539-39bcf8572dbe","cookieProLegacyDomain":".www.lenstore.fr","file":"fr-FR.json","currencyCode":"EUR","opticianBrandLogo":{"fileName":"","type":""}},{"code":"it-IT","country":"IT","iso":"it","domain":"www.lenstore.it","api":"https://api.lenstore.it","gtmContainerId":"GTM-PP3LRZD","cookieProId":"b06697b1-b0fb-4534-9621-97c709fbc248","cookieProLegacyDomain":".www.lenstore.it","file":"it-IT.json","currencyCode":"EUR","opticianBrandLogo":{"fileName":"grandvision","type":"svg"}}],
  defaultLocale: "en-GB",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: false,
  langDir: "~/language",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: true,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en-GB","country":"UK","iso":"en","domain":"www.lenstore.co.uk","api":"https://api.lenstore.co.uk","gtmContainerId":"GTM-PRPG3NS","cookieProId":"d5e286e2-7ed4-4826-99a3-691e6712cb1f","cookieProLegacyDomain":".www.lenstore.co.uk","file":"en-GB.json","currencyCode":"GBP","opticianBrandLogo":{"fileName":"vision-express","type":"png"}},{"code":"de-DE","country":"DE","iso":"de","domain":"www.lenstore.de","api":"https://api.lenstore.de","gtmContainerId":"GTM-PCSWQNN","cookieProId":"150bfe9b-de1c-458b-8e09-999cd4bcb0b2","cookieProLegacyDomain":".www.lenstore.de","file":"de-DE.json","currencyCode":"EUR","opticianBrandLogo":{"fileName":"apollo","type":"svg"}},{"code":"es-ES","country":"ES","iso":"es","domain":"www.lenstore.es","api":"https://api.lenstore.es","gtmContainerId":"GTM-K4P2MVD","cookieProId":"7d27f974-adf3-46cb-afd5-bce275e173c7","cookieProLegacyDomain":".lenstore.es","file":"es-ES.json","currencyCode":"EUR","opticianBrandLogo":{"fileName":"masvision","type":"svg"}},{"code":"fr-FR","country":"FR","iso":"fr","domain":"www.lenstore.fr","api":"https://api.lenstore.fr","gtmContainerId":"GTM-NKGFRFG","cookieProId":"d941b357-8916-4bc4-b539-39bcf8572dbe","cookieProLegacyDomain":".www.lenstore.fr","file":"fr-FR.json","currencyCode":"EUR","opticianBrandLogo":{"fileName":"","type":""}},{"code":"it-IT","country":"IT","iso":"it","domain":"www.lenstore.it","api":"https://api.lenstore.it","gtmContainerId":"GTM-PP3LRZD","cookieProId":"b06697b1-b0fb-4534-9621-97c709fbc248","cookieProLegacyDomain":".www.lenstore.it","file":"it-IT.json","currencyCode":"EUR","opticianBrandLogo":{"fileName":"grandvision","type":"svg"}}],
  localeCodes: ["en-GB","de-DE","es-ES","fr-FR","it-IT"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: "-",
  5: "G",
  6: "B",
  7: ".",
  8: "j",
  9: "s",
  10: "o",
  11: "n",
  12: "\"",
  13: ":",
  14: "\"",
  15: ".",
  16: ".",
  17: "/",
  18: "l",
  19: "a",
  20: "n",
  21: "g",
  22: "u",
  23: "a",
  24: "g",
  25: "e",
  26: "/",
  27: "e",
  28: "n",
  29: "-",
  30: "G",
  31: "B",
  32: ".",
  33: "j",
  34: "s",
  35: "o",
  36: "n",
  37: "\"",
  38: ",",
  39: "\"",
  40: "d",
  41: "e",
  42: "-",
  43: "D",
  44: "E",
  45: ".",
  46: "j",
  47: "s",
  48: "o",
  49: "n",
  50: "\"",
  51: ":",
  52: "\"",
  53: ".",
  54: ".",
  55: "/",
  56: "l",
  57: "a",
  58: "n",
  59: "g",
  60: "u",
  61: "a",
  62: "g",
  63: "e",
  64: "/",
  65: "d",
  66: "e",
  67: "-",
  68: "D",
  69: "E",
  70: ".",
  71: "j",
  72: "s",
  73: "o",
  74: "n",
  75: "\"",
  76: ",",
  77: "\"",
  78: "e",
  79: "s",
  80: "-",
  81: "E",
  82: "S",
  83: ".",
  84: "j",
  85: "s",
  86: "o",
  87: "n",
  88: "\"",
  89: ":",
  90: "\"",
  91: ".",
  92: ".",
  93: "/",
  94: "l",
  95: "a",
  96: "n",
  97: "g",
  98: "u",
  99: "a",
  100: "g",
  101: "e",
  102: "/",
  103: "e",
  104: "s",
  105: "-",
  106: "E",
  107: "S",
  108: ".",
  109: "j",
  110: "s",
  111: "o",
  112: "n",
  113: "\"",
  114: ",",
  115: "\"",
  116: "f",
  117: "r",
  118: "-",
  119: "F",
  120: "R",
  121: ".",
  122: "j",
  123: "s",
  124: "o",
  125: "n",
  126: "\"",
  127: ":",
  128: "\"",
  129: ".",
  130: ".",
  131: "/",
  132: "l",
  133: "a",
  134: "n",
  135: "g",
  136: "u",
  137: "a",
  138: "g",
  139: "e",
  140: "/",
  141: "f",
  142: "r",
  143: "-",
  144: "F",
  145: "R",
  146: ".",
  147: "j",
  148: "s",
  149: "o",
  150: "n",
  151: "\"",
  152: ",",
  153: "\"",
  154: "i",
  155: "t",
  156: "-",
  157: "I",
  158: "T",
  159: ".",
  160: "j",
  161: "s",
  162: "o",
  163: "n",
  164: "\"",
  165: ":",
  166: "\"",
  167: ".",
  168: ".",
  169: "/",
  170: "l",
  171: "a",
  172: "n",
  173: "g",
  174: "u",
  175: "a",
  176: "g",
  177: "e",
  178: "/",
  179: "i",
  180: "t",
  181: "-",
  182: "I",
  183: "T",
  184: ".",
  185: "j",
  186: "s",
  187: "o",
  188: "n",
  189: "\"",
  190: "}",
}

export const localeMessages = {
  'en-GB.json': () => Promise.resolve(localec5b99526),
  'de-DE.json': () => Promise.resolve(locale4e449542),
  'es-ES.json': () => Promise.resolve(locale35af4c7f),
  'fr-FR.json': () => Promise.resolve(locale6e349d82),
  'it-IT.json': () => Promise.resolve(locale7067459f),
}
